import {
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Textarea,
    Text
  } from '@chakra-ui/react';
import AdminModalContent from '../layout/AdminModalContent';
import { dangerButtonProps, secondaryButtonProps } from '../../theme/adminUi';

  const CancelModal = ({ isOpen, onClose, onConfirm, changeObservation }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <AdminModalContent>
          <ModalHeader fontSize="md">Cancelar el servicio</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontSize="sm" color="gray.600">
              ¿Confirmás la cancelación del servicio?
            </Text>
            <Textarea
              onChange={(e) => changeObservation(e)}
              placeholder="Motivo de cancelación"
              required
              mt={4}
              size="sm"
            />
          </ModalBody>
          <ModalFooter>
            <Button {...secondaryButtonProps} mr={3} onClick={onClose}>
              Volver
            </Button>
            <Button {...dangerButtonProps} onClick={onConfirm}>
              Confirmar cancelación
            </Button>
          </ModalFooter>
        </AdminModalContent>
      </Modal>
    );
  };
  
export default CancelModal;
